import { VehicleTypeEnums } from './Enums'

export const LoginFormSchema = () => [
	{
		type: 'input',
		label: 'Email',
		name: 'email',
		inputType: 'text',
		required: true,
		message: 'Email is required.',
		addonAfter: '@bridgelinxpk.com',
	},
	{
		type: 'password',
		label: 'Password',
		name: 'password',
		inputType: 'password',
		required: true,
		message: 'Password is required.',
	},
]

export const ForgotPasswordSchema = () => [
	{
		type: 'input',
		label: 'Email',
		name: 'email',
		inputType: 'text',
		required: true,
		message: 'Email is required.',
		addonAfter: '@bridgelinxpk.com',
	},
]

export const SignUpSchema = () => [
	{
		type: 'input',
		label: 'Email',
		name: 'email',
		inputType: 'text',
		required: true,
		message: 'Email is required.',
		addonAfter: '@bridgelinxpk.com',
	},
	{
		type: 'input',
		label: 'First Name',
		name: 'firstName',
		inputType: 'text',
		required: true,
		message: 'First name is required.',
	},
	{
		type: 'input',
		label: 'Last Name',
		name: 'lastName',
		inputType: 'text',
		required: true,
		message: 'Last name is required.',
	},
]

export const BiltyTypeSchema = () => [
	{
		type: 'radioGroup',
		name: 'biltyType',
		label: 'Bilty Type',
		dataObject: {
			systemGenerated: { key: 'systemGenerated', long: 'System Generated' },
			manual: { key: 'manual', long: 'Manual' },
		},
		initialValue: 'systemGenerated',
		layout: 'horizontal',
	},
]

export const InitialBiltyDetailsSchema = ({ document, uploadID, setLoading }) => [
	{
		hideDivider: true,
		hideLabel: true,
		fields: [
			{
				type: 'input',
				label: 'Bilty Number',
				name: [document, 'biltyNumber'],
				placeholder: 'Enter Bilty Number',
				required: true,
				message: 'Bilty number is required.',
			},
			{
				type: 'upload',
				label: 'Bility Document',
				name: [document, 'halfDoneBiltyDocument'],
				multiple: true,
				initialValue: [],
				uploadMessage: 'UPLOAD BILTY',
				uploadLink: uploadID,
				setLoading: setLoading,
				required: true,
				message: 'Bilty document is required.',
			},
		],
	},
]

export const BiltyDetailsSchema = ({ segment, document, uploadID, setLoading }) => [
	{
		hideDivider: true,
		hideLabel: true,
		itemsPerRow: 3,
		fields: [
			{
				type: 'upload',
				label: 'Stamped Bilty',
				name: [document, 'biltyDocument'],
				uploadMessage: 'UPLOAD BILTY DOCUMENT',
				uploadLink: uploadID,
				setLoading: setLoading,
				required: true,
				message: 'Bilty proof is required',
			},
			...(segment === 'Import'
				? [
						{
							type: 'upload',
							label: 'Final EIR',
							name: [document, 'eirDocument'],
							uploadMessage: 'UPLOAD EIR DOCUMENT',
							uploadLink: uploadID,
							setLoading: setLoading,
						},
				  ]
				: []),
		],
	},
]

export const DriverDetailsSchema = ({ uploadID, setLoading, isLot = false, biltyNumber = false }) => {
	return [
		{
			label: 'Please provide driver details',
			fields: [
				{
					type: 'input',
					label: 'Driver Name',
					name: 'driverName',
					placeholder: 'Enter Name',
					required: true,
					message: 'Driver name is required.',
				},
				{
					type: 'phoneNumber',
					label: 'Driver Number',
					name: 'driverPhone',
					placeholder: 'Enter Phone Number',
					required: true,
					message: 'Driver phone is required.',
					addonBefore: '+92',
					disabled: !biltyNumber && isLot,
				},
				{
					type: 'vehicleRegistration',
					label: 'Vehicle Number',
					name: 'driverVehicleRegistration',
					placeholder: 'Enter Vehicle Number',
					required: true,
					message: 'Vehicle number is required.',
					disabled: !biltyNumber && isLot,
				},
				{
					type: 'select',
					label: 'Vehicle Type',
					name: 'vehicleType',
					message: 'Please select a vehicle type',
					required: true,
					options: Object.values(VehicleTypeEnums)?.map((vehicle) => ({ key: vehicle?.key, value: vehicle?.text })),
					displayProperty: 'value',
					valueProperty: 'key',
					placeholder: 'Select vehicle type',
				},
				{
					type: 'cnic',
					label: 'CNIC Number',
					name: 'driverCNIC',
					placeholder: 'Enter CNIC Number',
					required: true,
					message: 'CNIC number is required.',
				},
				{
					type: 'upload',
					label: "Driver's CNIC",
					name: 'driverCNICDocument',
					uploadMessage: 'UPLOAD DRIVER CNIC',
					uploadLink: uploadID,
					setLoading: setLoading,
				},
			],
		},
	]
}

export const TrackerAvailabilitySchema = ({ trackers }) => {
	return [
		{
			type: 'radioGroup',
			hideDivider: true,
			name: 'trackerAvailable',
			label: 'Tracker Information',
			dataObject: {
				available: { key: 'available', long: 'Available' },
				notAvailable: { key: 'notAvailable', long: 'Not Available' },
			},
			initialValue: 'available',
			layout: 'horizontal',
		},
		{
			type: 'dependency',
			hideDivider: true,
			name: 'trackerAvailableDependency',
			independent: 'trackerAvailable',
			condition: ['available'],
			successSchema: [
				{
					type: 'select',
					label: 'Tracker Number',
					name: 'trackerId',
					message: 'Please Select a Tracker',
					hideLabel: true,
					required: true,
					showSearch: true,
					options: trackers,
					displayProperty: 'value',
					valueProperty: 'key',
					placeholder: 'Enter Tracker No.',
					itemClassName: 'w-1/2 !mr-4 !my-auto',
				},
			],
			failureSchema: [
				{
					type: 'select',
					label: 'Tracker Missing Reason',
					name: 'trackerComment',
					message: 'Please Add a Valid Reason',
					hideLabel: true,
					required: true,
					options: [
						{ key: 'noChargingPort', value: 'No Charging Port' },
						{ key: 'notAvailable', value: 'Tracker Unavailable' },
						{ key: 'faultyTracker', value: 'Faulty Tracker' },
						{ key: 'munshiIssue', value: 'Tracker Not Installed By Munshi' },
						{ key: 'clientPreference', value: 'Client Does Not Need A Tracker' },
					],
					displayProperty: 'value',
					valueProperty: 'key',
					placeholder: 'Enter Reason.',
					itemClassName: 'w-1/2 !mr-4 !my-auto',
				},
			],
		},
	]
}

export const TrackerRecievedSchema = ({ record }) => {
	return [
		...(record?.trackerId
			? [
					{
						label: 'Tracker Received?',
						fields: [
							{
								type: 'radioGroup',
								name: 'removeTracker',
								label: 'Tracker Received',
								dataObject: {
									true: { key: true, long: 'Yes' },
									false: { key: false, long: 'No' },
								},
								layout: 'horizontal',
							},
						],
					},
			  ]
			: []),
	]
}

export const InitialKantaSchema = ({ document, uploadID, setLoading, required }) => {
	return [
		{
			hideDivider: true,
			hideLabel: true,
			itemsPerRow: 3,
			fields: [
				{
					type: 'number',
					label: 'Kanta Weight',
					required: required,
					name: [document, 'initialKantaWeight'],
					placeholder: 'Enter Kanta weight',
					message: 'Initial Kanta weight is required.',
				},
				{
					type: 'number',
					label: 'Kanta Charges',
					required: required,
					name: [document, 'initialKantaCharges'],
					placeholder: 'Enter Kanta Amount',
					message: 'Initial Kanta charges are required.',
				},
				{
					type: 'upload',
					label: 'Kanta Receipt',
					name: [document, 'initialKantaDocument'],
					uploadMessage: 'UPLOAD RECEIPT',
					required: required,
					uploadLink: uploadID,
					setLoading: setLoading,
					message: 'Initial Kanta receipt is required.',
				},
			],
		},
	]
}

export const FinalKantaSchema = ({ document, record, setLoading }) => {
	return [
		{
			hideDivider: true,
			hideLabel: true,
			itemsPerRow: 3,
			fields: [
				{
					type: 'number',
					label: 'Kanta Weight',
					name: [document, 'kantaWeight'],
					placeholder: 'Enter Kanta weight',
					initialValue: record?.bilty?.initialKantaWeight,
				},
				{
					type: 'number',
					label: 'Kanta Charges',
					name: [document, 'kantaCharges'],
					placeholder: 'Enter Kanta Amount',
					initialValue: record?.bilty?.initialKantaCharges,
				},
				{
					type: 'upload',
					label: 'Kanta Receipt',
					name: [document, 'kantaDocument'],
					uploadMessage: 'UPLOAD RECEIPT',
					uploadLink: record?._id,
					setLoading: setLoading,
					initialValue:
						record?.bilty?.initialKantaDocument &&
						record?.bilty?.initialKantaDocument.map((doc, index) => [{ uid: index + 1, name: `Kanta Document (${index + 1})`, status: 'done', url: doc }]),
				},
			],
		},
	]
}

export const CreationAdditionalDetailsSchema = ({ segment, uploadID, setLoading }) => {
	return [
		{
			label: 'Additional Information',
			fields: [
				...(segment === 'Import'
					? [
							{
								type: 'input',
								label: 'Seal Number',
								name: 'seal',
								placeholder: 'Enter Seal Number',
							},
							{
								type: 'input',
								label: 'LC Number',
								name: 'lcNumber',
								placeholder: 'Enter LC Number',
							},
							{
								type: 'upload',
								label: 'Gate Pass Upload',
								name: 'gatePassDocument',
								uploadMessage: 'UPLOAD GATE PASS',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
							{
								type: 'upload',
								label: 'EIR Upload',
								name: 'initialEirDocument',
								uploadMessage: 'UPLOAD EIR',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
					  ]
					: segment === 'Export'
					? [
							{
								type: 'upload',
								label: 'CRO Upload',
								name: 'croDocument',
								uploadMessage: 'UPLOAD CRO',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
							{
								type: 'upload',
								label: 'EIR Upload',
								name: 'initialEirDocument',
								uploadMessage: 'UPLOAD EIR',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
					  ]
					: []),
				{
					type: 'number',
					label: 'Munshiana',
					name: 'munshiana',
					required: true,
					placeholder: 'Enter Munshiana',
				},
				{
					type: 'input',
					label: 'Remarks',
					name: 'remarks',
					placeholder: 'Enter Remarks',
				},
			],
		},
	]
}

export const PostCreationAdditionalDetailsSchema = ({ segment, uploadID, setLoading }) => {
	return [
		{
			label: 'Additional Details',
			fields: [
				...(segment !== 'LongHaul'
					? [
							{
								type: 'number',
								label: 'LOLO Charges',
								name: 'loloCharges',
								placeholder: 'Enter LOLO Amount',
							},
							{
								type: 'upload',
								label: 'Lolo Receipt',
								name: 'loloDocument',
								uploadMessage: 'UPLOAD LOLO',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
					  ]
					: []),
				...(segment === 'Import'
					? [
							{
								type: 'number',
								label: 'Rotational Charges',
								name: 'rotationalCharges',
								placeholder: 'Enter Rotational Amount',
							},
							{
								type: 'upload',
								label: 'Rotational Receipt',
								name: 'rotationalReceipt',
								uploadMessage: 'UPLOAD RECEIPT',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
							{
								type: 'number',
								label: 'Amanat',
								name: 'amanat',
								placeholder: 'Enter Amanat',
							},
							{
								type: 'upload',
								label: 'Upload Amanat',
								name: 'amanatUpload',
								uploadMessage: 'UPLOAD AMANAT',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
							{
								type: 'number',
								label: 'Offloading Charges',
								name: 'offLoadingCharges',
								placeholder: 'Enter Offloading Charges',
							},
							{
								type: 'upload',
								label: 'Upload Offloading Receipt',
								name: 'offLoadingUpload',
								uploadMessage: 'UPLOAD OFFLOADING',
								uploadLink: uploadID,
								setLoading: setLoading,
							},
							{
								type: 'number',
								label: 'Placement Charges',
								name: 'placementCharges',
								placeholder: 'Enter Placement Amount',
							},
							{
								type: 'number',
								label: 'Repairing Charges',
								name: 'repairingCharges',
								placeholder: 'Enter Repairing Charges',
							},
					  ]
					: []),
				{
					type: 'dateTime',
					label: 'Gate In',
					name: 'gateIn',
					format: 'DD-MM-YYYY HH:mm',
					showTime: true,
				},
				{
					type: 'dateTime',
					label: 'Gate Out',
					name: 'gateOut',
					format: 'DD-MM-YYYY HH:mm',
					showTime: true,
				},
			],
		},
	]
}

export const CancelBiltySchema = (record) => {
	return [
		{
			type: 'statement',
			name: 'cancelBilty',
			sentence: `Do you want to cancel bilty ${record?.bilty?.biltyNumber}.`,
		},
		{
			type: 'textArea',
			name: 'cancelReason',
			required: true,
			label: 'Reason for cancellation',
			message: 'Reason for cancellation is required.',
		},
	]
}

export const AssignVicinitiesSchema = (props) => {
	const { vicinities, form, record } = props

	return [
		{
			type: 'checkboxGroup',
			label: 'Regions',
			name: 'assignRegions',
			options: vicinities,
			values: record?.regions?.map((region) => region?.value),
			formReference: form,
		},
	]
}

export const MarkTrackingCompleteSchema = () => {
	return [
		{
			type: 'statement',
			name: 'trackingComplete',
			sentence: 'Do you want to mark tracking as completed?',
		},
	]
}

export const CreateTrackerSchema = () => {
	return [
		{
			type: 'input',
			label: 'Tracker Name',
			name: 'name',
			placeholder: 'Enter Tracker Name',
			required: true,
			message: 'Tracker Name is required.',
		},
		{
			type: 'select',
			label: 'Provider',
			hideLabel: true,
			required: true,
			message: 'Provider is Required',
			name: 'provider',
			options: [{ key: 'Telenor', value: 'Telenor' }],
			displayProperty: 'value',
			valueProperty: 'key',
			placeholder: 'Enter Provider',
		},
	]
}

export const AddMissingKantaSchema = (record, setLoading) => {
	return [
		{
			type: 'number',
			label: 'Kanta Weight',
			name: 'kantaWeight',
			placeholder: 'Enter Kanta weight',
			initialValue: record?.bilty?.initialKantaWeight,
		},
		{
			type: 'number',
			label: 'Kanta Charges',
			name: 'kantaCharges',
			placeholder: 'Enter Kanta Amount',
			initialValue: record?.bilty?.initialKantaCharges,
		},
		{
			type: 'upload',
			label: 'Kanta Receipt',
			name: 'kantaDocument',
			uploadMessage: 'UPLOAD RECEIPT',
			uploadLink: record?._id,
			setLoading: setLoading,
			initialValue:
				record?.bilty?.initialKantaDocument &&
				record?.bilty?.initialKantaDocument.map((doc, index) => [{ uid: index + 1, name: `Kanta Document (${index + 1})`, status: 'done', url: doc }]),
		},
	]
}
